import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";

const Ctx = createContext(null);
const KEY = "sj_compare_v2";
export const MAX_COMPARE = 3;
export const COMPARE_CATS = { "board-products": "boards", "stone-options": "stones" };

const load = () => {
  try {
    const v = JSON.parse(localStorage.getItem(KEY));
    return COMPARE_CATS[v?.category] && Array.isArray(v?.ids) ? { category: v.category, ids: v.ids.slice(0, MAX_COMPARE) } : { category: "", ids: [] };
  } catch {
    return { category: "", ids: [] };
  }
};

export const CompareProvider = ({ children }) => {
  const [state, setState] = useState(load);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(state));
  }, [state]);

  const toggle = (item) => {
    const { category, ids } = state;
    if (ids.includes(item.id)) return setState({ category, ids: ids.filter((x) => x !== item.id) });
    if (category && category !== item.category && ids.length) {
      toast(`Started a new comparison of ${COMPARE_CATS[item.category]}`);
      return setState({ category: item.category, ids: [item.id] });
    }
    if (ids.length >= MAX_COMPARE) return toast(`You can compare up to ${MAX_COMPARE} ${COMPARE_CATS[item.category]}. Remove one first.`);
    setState({ category: item.category, ids: [...ids, item.id] });
  };

  const value = {
    ids: state.ids,
    category: state.category,
    noun: COMPARE_CATS[state.category] || "items",
    toggle,
    remove: (id) => setState((s) => ({ ...s, ids: s.ids.filter((x) => x !== id) })),
    clear: () => setState({ category: "", ids: [] }),
    has: (id) => state.ids.includes(id),
  };
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
};

export const useCompare = () => useContext(Ctx);
export const isComparable = (item) => Boolean(COMPARE_CATS[item?.category]);
